import React from "react";
import PropTypes from "prop-types";

const AppWrap = (Component, idName, classNames = "") =>
  function HOC() {
    return (
      <section
        id={idName}
        className={`relative flex justify-center w-full ${classNames}`}
      >
        <div className="w-full max-w-6xl px-5 md:px-10 lg:px-12 py-16 lg:py-24">
          <Component />
          {idName === "footer" && (
            <div className="mt-14 pt-6 border-t border-white/5 text-xs text-slate-500 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
              <p>(c) 2026 Nishan Neupane</p>
              <p className="text-slate-400">Kathmandu - Working worldwide</p>
            </div>
          )}
        </div>
      </section>
    );
  };

AppWrap.propTypes = {
  Component: PropTypes.elementType.isRequired,
  idName: PropTypes.string.isRequired,
  classNames: PropTypes.string,
};

export default AppWrap;
